export enum RecipientListSectionsEnum {
  SHS = 'Helse- og Sosial',
  SKA = 'Kontor og Administrasjon',
  SKKO = 'Kirke, Kultur og Oppvekst',
  SST = 'Samferdsel og Teknisk',
}
